// material-ui
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';

// assets
import { LogoutOutlined } from '@ant-design/icons';
import useAuth from 'hooks/useAuth';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

interface Props {
  handleLogout: () => void;
}

const ProfileTab = ({ handleLogout }: Props) => {
  const { user } = useAuth();
  const toTitleCase = (str: string) => {
    try {
      return str.trim().toLowerCase().split(' ').map(function (word) {
        return word.replace(word[0], word[0].toUpperCase());
      }).join(' ');
    }
    catch {
      return str;
    }
  }

  if (!!!user)
    return (<></>);
  else
    return (
      <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
        <ListItemText sx={{ ml: 1, mt: 1 }} primary={`${user.name ?? ''}`} />
        <ListItemText sx={{ ml: 1, mt: 0 }} primary={`${user.companyName ?? ''}`} />
        <ListItemText sx={{ ml: 1, mt: 0 }} primary={`${toTitleCase(user.address ?? '')}`} />
        <ListItemText sx={{ ml: 1, mt: 0 }} primary={`${toTitleCase(user.city ?? '')}, ${user.state ?? ''}`} />
        <ListItemText sx={{ ml: 1, mt: 0 }} primary={`${user.phone ?? ''}`} />
        <ListItemText sx={{ ml: 1, mt: 0 }} primary={`${toTitleCase(user.email ?? '')}`} />
        <ListItemButton onClick={handleLogout}>
          <ListItemIcon>
            <LogoutOutlined />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItemButton>
      </List>
    );
};

export default ProfileTab;
